<div class="special-table-container">
    <div class="sub-table-section mx-30 my-20" *ngIf="currentMasterRowData.paymentType === 'POSTPAID'">
        <h4 class="mb-15 text-neutral-n7">Tiers</h4>
        <div>
            <ag-grid-angular class="ag-theme-alpine" rowMultiSelectWithClick="false" suppressRowClickSelection="true" suppressDragLeaveHidesColumns="true"
                suppressMenuHide="true" enableCellTextSelection="true" suppressPaginationPanel="true" domLayout="autoHeight" suppressCellSelection="true"
                suppressContextMenu="true" rowHeight="36" headerHeight="36" [rowData]="tierRowData" [columnDefs]="tiersColumnDefs"
                [defaultColDef]="defaultColDef" (gridReady)="onTierGridReady($event)"></ag-grid-angular>
        </div>
    </div>
    <div class="sub-table-section mx-30 my-20" *ngIf="currentMasterRowData.paymentType === 'PREPAID'">
        <h4 class="mb-15 text-neutral-n7">Bundles</h4>
        <div>
            <ag-grid-angular class="ag-theme-alpine" rowMultiSelectWithClick="false" suppressRowClickSelection="true" domLayout="autoHeight"
                suppressDragLeaveHidesColumns="true" suppressMenuHide="true" enableCellTextSelection="true" suppressPaginationPanel="true"
                suppressCellSelection="true" suppressContextMenu="true" rowHeight="36" headerHeight="36" [rowData]="bundleRowData"
                [columnDefs]="bundlesColumnDefs" [defaultColDef]="defaultColDef" (gridReady)="onBundlesGridReady($event)"></ag-grid-angular>
        </div>
    </div>
    <div class="sub-table-section mx-30 my-20" *ngIf="analyticsTariffRowData?.length > 0">
        <h4 class="mb-15 text-neutral-n7">Analytics</h4>
        <div>
            <ag-grid-angular class="ag-theme-alpine" rowMultiSelectWithClick="false" suppressRowClickSelection="true" domLayout="autoHeight"
                suppressDragLeaveHidesColumns="true" suppressMenuHide="true" enableCellTextSelection="true" suppressPaginationPanel="true"
                suppressCellSelection="true" suppressContextMenu="true" rowHeight="36" headerHeight="36" [rowData]="analyticsTariffRowData"
                [columnDefs]="analyticsTariffColumnDefs" [defaultColDef]="defaultColDef" (gridReady)="onAnalyticsTariffGridReady($event)"></ag-grid-angular>
        </div>
    </div>
</div>
